import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        const userSessionKey = 'wa360_session';
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const getTopLevelDomain = (domain) => {
            // this should return only the
            // extension and the top level of the domain
            // ex: futurewalottery.com
            // from stg01.mylottery360.futurewalottery.com
            return domain.split('.').slice(-2).join('.');
        };

        const setCookieValueByName = (cookieName, cookieValue) => {
            if (typeof document === 'undefined') {
                return;
            }

            document.cookie = `${cookieName}=${cookieValue}; Path=/; Domain=${getTopLevelDomain(document.location.hostname)}; SameSite=None; Secure`;
            return cookieValue;
        };

        let result = null;

        // Making the API call based on the PTA version
        if (payload.pta_version === 'v1') {
            // for GA Desktop (IGT)
            result = await apiClient(config).apiMethod({
                method: 'PlayerLoginPTAV1',
                args: {
                    pta_version: 'v1',
                    playerID: payload.playerID,
                    registrar_id: payload.registrar_id,
                    firstName: payload.firstName,
                    lastName: payload.lastName,
                    email: payload.email,
                    address1: payload.address1,
                    address2: payload.address2,
                    city: payload.city,
                    stateAbbr: payload.stateAbbr,
                    zip: payload.zip,
                    dob: payload.dob,
                    phonenumber: payload.phonenumber,
                    chksum: payload.chksum,
                },
            });
        } else {
            // default: V2
            result = await apiClient(config).apiMethod({
                method: 'PlayerLoginPTAV2',
                args: {
                    pta_version: 'v2',
                    hash: payload.hash,
                    iv: payload.iv,
                    data: payload.data,
                },
            });
        }

        let player = result.player;
        let loggedIn = player ? true : false;
        if (loggedIn) {
            setCookieValueByName(appCookieKey, result.token);
            let cookie = JSON.stringify({
                token: result.token,
                spat: result.spat,
                expires: '',
            });
            setCookieValueByName(sharedCookieKey, cookie);

            return {
                loggedIn: loggedIn,
                player: {
                    registrar_id: player.registrar_id,
                    name: player.firstname + ' ' + player.lastname,
                    email: player.email,
                    first_name: player.firstname,
                    last_name: player.lastname,
                    email_confirm: player.email,
                },
            };
        } else if (result.code) {
            return {
                loggedIn: false,
                errors: result.code,
            };
        } else {
            return {
                loggedIn: false,
                errors: 'Unspecified Error',
            };
        }
    };
};
